/**
 * Cheap implementation of @hotwired/stimulus-loader
 * This allows reduced naming redundancy in component controller files
 * Parses all passed Stimulus controller modules
 * Returns the module with a stimulus identifier based on the folder the controller was in
 * Ex.
 *  alert/controller.js -> alert-controller
 *  alert/warning/controller.js -> alert--warning-controller
 */
// export const registerControllers = (application, controllers, nesting = false) => {
//   return Object.entries(controllers).map(([path, moduleLoader]) => {
//     const identifier = path
//       .match(/components\/(.+)\/controller\.js$/)?.[1]
//       ?.replace(/\//g, '--')
//       ?.replace(/_/g, '-');

//     if (!identifier) return null;

//     return {
//       identifier,
//       controllerConstructor: async() => {
//         const mod = await moduleLoader();
//         return mod.default || mod;
//       }
//     };
//   }).filter(Boolean);
// };


const CONTROLLER_FILENAME_REGEX = /^(?:.*?(?:controllers|components)\/|\.?\.\/)?(.+)(?:[/_-]controller\..+?)$/;

const identifierForGlobKey = (key, identifierNesting) => {
  const logicalName = (key.match(CONTROLLER_FILENAME_REGEX) || [])[1];
  if (logicalName && identifierNesting) return logicalName.replace(/_/g, '-').replace(/\//g, '--');
  else if (logicalName && !identifierNesting) return logicalName.replace(/_/g, '-').replace(/^.*\//, '');
};

const definitionsFromGlob = (controllerModules, identifierNesting) => {
  return Object.entries(controllerModules).map(([name, controllerModule]) => {
    const identifier = identifierForGlobKey(name, identifierNesting);

    // * Uncomment to debug controller identifier outputs if your controller is not connecting
    // console.log(identifier);
    const controllerConstructor = (controllerModule).default ?? controllerModule;
    if (identifier && typeof controllerConstructor === 'function') return { identifier, controllerConstructor };
  // eslint-disable-next-line no-unused-expressions
  }).filter(Boolean);
};

/**
 * A customization of https://github.com/ElMassimo/stimulus-vite-helpers
 * Allows the registration of stimulus controllers from vite glob imports
 *
 * identifierNesting controls the generation of the stimulus controller identifier.
 *
 * By default, it will namespace the controller based the files nesting structure.
 *
 * (example) with the file javascript/controllers/portal/components/button
 *
 * identifierNesting = true -> portal--components--button
 *
 * identifierNesting = false -> button
 *
 * @param {Object} application - The Stimulus application object
 * @param {Object[]} controllerModules - Modules loaded by import.meta.glob
 * @param {any} [identifierNesting=true] - (default=true) Should the identifier be namespaces based on file nesting?
 */
export const registerControllers = (application, controllerModules, identifierNesting = true) => {
  application.load(definitionsFromGlob(controllerModules, identifierNesting));
};
